import { type ReactNode } from 'react'
import { isPathAllowed } from 'auth/roles'
import { useUserRoles } from 'hooks/useUserRoles'

type Props = { path: string; children: ReactNode }

export function RouteGate({ path, children }: Props) {
  const roles = useUserRoles()
  if (!isPathAllowed(path, roles)) return null
  return <>{children}</>
}
